/*
 * Project: bellcloud
 * File: packages/theme/tokens/radius.ts
 * Description: Border radius tokens based on Bellcloud Design System
 */

export type RadiusTokens = {
  none: number;
  sm: number;
  md: number;
  lg: number;
  full: number;
};

export const radius: RadiusTokens = {
  none: 0,
  sm: 2,
  md: 4,
  lg: 8,
  full: 9999,
};
